module.exports = __webpack_public_path__ + "fix-flip-2.921e649.png";